<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-23 11:47:57
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-10 16:02:31
 * @name: 穿梭框弹窗
 * @Description: 穿梭框弹窗
 * @FilePath: \preSaleNafterSaleBackstage\src\components\public\transfer-dialog.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <dialogNormal ref="dialogNormal" width="60%" :title="title" @close="close">
    <template v-slot:main>
      <div style="width: 100%;display: flex;justify-content: center;">
        <el-transfer style="display: inline-block;" v-model="value" :data="data" :titles="['未选', '已选']"></el-transfer>
      </div>
    </template>
    <template v-slot:foot>
      <el-button class="submit" type="primary" @click="submit">确定</el-button>
    </template>
  </dialogNormal>
</template>
<script>
import dialogNormal from "@/components/public/dialog-normal.vue";

export default {
  name: "transferDialog",
  components: {
    dialogNormal,
  },
  data() {
    return {
      title: "",
      data: [],
      value: [],
    };
  },
  methods: {
    open(title, arr, value = []) {
      this.title = title;
      this.data = arr;
      this.value = value;
      this.$refs.dialogNormal.open();
    },
    cancel() {
      this.$refs.dialogNormal.close();
    },
    close() {
      this.title = "";
      this.data = [];
      this.value = [];
    },
    submit() {
      this.$emit("back", this.data.filter(x => this.value.findIndex(y => y === x.key) > -1));
      this.cancel();
    },
  },
};
</script>
<style lang="scss" scoped>
.submit {
  width: $Var-button-width-normal;
}
</style>